import React from 'react';
import { PropTypes } from 'prop-types';

import { Field } from '@ontruck/orc';
import AddressSuggestionsSelector from '../AddressSuggestionsSelector';
import ResponsiveModal from 'components/ResponsiveModal';
import { constants as addressesConstants } from 'utils/addresses';

const AddressCompanyNameField = ({
  className,
  responsiveModalRef,
  inputModalRef,
  inputRef,
  companyName,
  handleChange,
  handleInputModalFocus,
  handleInputFocus,
  handleInputBlur,
  invalid,
  error,
  venues,
  handleSuggestionSelected,
  t,
  names,
}) => (
  <ResponsiveModal
    className={className}
    modalRef={responsiveModalRef}
    inputRef={inputRef}
    refProperty="fieldRef"
    header={
      <Field
        type="text"
        id={names.company_name}
        name={names.company_name}
        fieldRef={inputModalRef}
        label={t('label_company_name')}
        onChange={handleChange}
        onFocus={handleInputModalFocus}
        size="L"
        fullWidth
        invalid={invalid}
        error={error}
        value={companyName}
      />
    }
    content={
      venues.length > 0 ? (
        <AddressSuggestionsSelector
          options={venues}
          onSuggestionClicked={handleSuggestionSelected}
          suggestionType={addressesConstants.POI_ADDRESS_CONSTANTS.venue_type}
        />
      ) : null
    }
  >
    <Field
      type="text"
      id={names.company_name}
      name={names.company_name}
      fieldRef={inputModalRef}
      label={t('label_company_name')}
      onChange={handleChange}
      onFocus={handleInputFocus}
      onBlur={handleInputBlur}
      size="L"
      fullWidth
      invalid={invalid}
      error={error}
      value={companyName}
    />
  </ResponsiveModal>
);

AddressCompanyNameField.propTypes = {
  responsiveModalRef: PropTypes.func,
  inputModalRef: PropTypes.func,
  inputRef: PropTypes.func,
  companyName: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleInputModalFocus: PropTypes.func,
  handleInputFocus: PropTypes.func,
  handleInputBlur: PropTypes.func,
  invalid: PropTypes.bool,
  error: PropTypes.bool,
  venues: PropTypes.arrayOf(addressesConstants.PROP_TYPES.address_suggestion),
  handleSuggestionSelected: PropTypes.func,
  t: PropTypes.func.isRequired,
  names: addressesConstants.PROP_TYPES.address,
};

AddressCompanyNameField.defaultProps = {
  className: '',
  responsiveModalRef: () => {},
  inputModalRef: () => {},
  inputRef: () => {},
  companyName: '',
  handleInputModalFocus: () => {},
  handleInputFocus: () => {},
  handleInputBlur: () => {},
  invalid: false,
  error: false,
  handleSuggestionSelected: () => {},
  venues: [],
  names: {},
};

export default AddressCompanyNameField;
